import { createMongoAbility, type MongoAbility, type RawRuleOf } from '@casl/ability'

export type AppAbility = MongoAbility
export type AbilityRule = RawRuleOf<AppAbility>

/**
 * Permissions arrive with the authenticated user; until auth lands the ability
 * is empty, so every `can()` answers false and permission-gated UI stays hidden.
 */
export const ability: AppAbility = createMongoAbility([])

/** Called once the authenticated profile (and its rules) has loaded. */
export function setAbilityRules(rules: AbilityRule[]): void {
  ability.update(rules)
}

/** Called on logout, so the next user never inherits the previous one's rules. */
export function resetAbility(): void {
  ability.update([])
}

export default ability
